import React from 'react';
import { Row, Col, Alert, Clearfix, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import EntityPropsUpdater from 'component/EntityPropsUpdater';
import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import _, { forEach as _forEach } from 'lodash';
import Modal from '../../Modal';
import DateTimePicker from '../../forms/DateTimePicker';
import Loader from '../Loader';
import moment from 'moment';
import { getTimezoneFromState } from '../../../helpers/intl';
import { editServiceTypeClientR } from '../../../actions/ServiceTypesActions';
import FormLangInput from '../../forms/FormLangInput';
import FormLangRichEditor from '../../forms/FormLangRichEditor';

class ClientProvisionServiceEdit extends EntityPropsUpdater {
  constructor(props) {
    super(props);
    this.state = {
      provisionService: undefined, // as title and type
      name: undefined,
      title: undefined,
      description: undefined,
      primary_owner: undefined,
      secondary_owner: undefined,
      primary_rate: undefined,
      secondary_rate: undefined,
      periodStart: moment(Date.now()),
      periodEnd: moment(Date.now()),
      client: undefined,
      id: undefined,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
    } = this.props;
    if (prevProps.show !== this.props.show && this.props.show === true) {
      let serviceTypesR = this.props.serviceTypesClientR; //[{id: "123", provisionService: messages.service_type_onboarding, type: "onboarding", rate1: 10, rate2: 5, primary_owner: "primary_owner", secondary_owner: "secondary_owner", newDateTime:  moment(Date.now()), }]
      const index = _.findIndex(serviceTypesR, serviceTypeR => serviceTypeR.id === this.props.serviceTypeId);
      if (index !== -1) {
        this.setState({
          name: serviceTypesR[index]?.name,
          title: serviceTypesR[index]?.title,
          description: serviceTypesR[index]?.description,
          id: serviceTypesR[index]?.id,
          provisionService: serviceTypesR[index]?.service_type?.id,
          primary_owner: serviceTypesR[index]?.primary_owner,
          secondary_owner: serviceTypesR[index]?.secondary_owner,
          primary_rate: serviceTypesR[index]?.primary_rate,
          secondary_rate: serviceTypesR[index]?.secondary_rate,
          periodStart: serviceTypesR[index]?.period_start,
          periodEnd: serviceTypesR[index]?.period_end,
          client: undefined,
        });
      }
    }
  };

  editServiceType = () => {
    const {
      name,
      title,
      description,
      client,
      primary_owner,
      secondary_owner,
      primary_rate,
      secondary_rate,
      periodStart,
      periodEnd,
      provisionService,
    } = this.state;

    let data = {
      name: name,
      title: title,
      description: description,
      serviceType: provisionService,
      primaryRate: primary_rate,
      secondaryRate: secondary_rate,
      primaryOwner: primary_owner,
      secondaryOwner: secondary_owner,
      client: this.props.entity?.data?.username,
      periodStart: periodStart,
      periodEnd: periodEnd,
    };
    this.props.editServiceTypeClientR(this.props.serviceTypeId, data);
    this.props.close();
  };

  setProvisionService = value => {
    let _primaryRate = this.props.serviceTypesR[
      _.findIndex(this.props.serviceTypesR, serviceTypeR => serviceTypeR.id === value)
    ].primary_rate;
    let _secondaryRate = this.props.serviceTypesR[
      _.findIndex(this.props.serviceTypesR, serviceTypeR => serviceTypeR.id === value)
    ].secondary_rate;
    this.setState({ provisionService: value, primary_rate: _primaryRate, secondary_rate: _secondaryRate });
  };

  resetAndClose = () => {
    this.setState({ name: undefined, description: undefined }, () => {
      this.props.close();
    });
  };

  translateTitle = i => {
    const index = _.findIndex(this.props.serviceTypesR[i].title, title => title.lang === this.props.appIntl.locale);
    return this.props.serviceTypesR[i].title[index].name; //or name
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      disabled,
      user,
      show,
      close,
      defaultTimezone,
      appIntl,
    } = this.props;
    const {
      name,
      title,
      description,
      client,
      primary_owner,
      secondary_owner,
      primary_rate,
      secondary_rate,
      periodStart,
      periodEnd,
      provisionService,
    } = this.state;

    let type_options = [];
    _forEach(this.props.serviceTypesR, (service, i) => {
      let type_options_data = { serviceName: this.translateTitle(i) + ' - ' + service.name, value: service.id };
      type_options.push(type_options_data);
    });

    let editDisabled = 'disabled';
    if (provisionService !== undefined && primary_rate !== undefined && secondary_rate !== undefined) {
      editDisabled = '';
    } else {
      editDisabled = 'disabled';
    }

    return (
      <Modal show={show} onHide={this.resetAndClose} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.edit_provision_service}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div>
                <h4></h4>
              </div>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm">
                <FormInput
                  type="text"
                  label={messages.provision_service_client_name}
                  name="name"
                  onChange={(name, value) => this.setState({ name: value })}
                  value={this.state.name}
                  disabled=""
                />
                <FormLangInput
                  label={messages.provision_service_title}
                  name="title"
                  value={this.state.title}
                  onChange={(name, value) => this.setState({ title: value })}
                />
                {this.state.description !== undefined ? (
                  <FormLangRichEditor
                    name="description"
                    label={messages.provision_service_description_text}
                    value={this.state.description}
                    onChange={(name, value) => this.setState({ description: value })}
                  />
                ) : (
                  <></>
                )}
                <DateTimePicker
                  value={periodStart}
                  label={messages.provision_start}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={(name, value) => this.setState({ periodStart: value })}
                />
                <DateTimePicker
                  value={periodEnd}
                  label={messages.provision_ending}
                  locale={appIntl.locale}
                  displayTz={defaultTimezone}
                  onChange={(name, value) => this.setState({ periodEnd: value })}
                />
                {this.state.provisionService !== undefined ? (
                  <FormAutocomplete
                    onChange={(name, value) => this.setProvisionService(value)}
                    label={messages.provision_service}
                    name="type"
                    value={this.state.provisionService}
                    options={type_options.map(option => {
                      return { label: option.serviceName, value: option.value };
                    })}
                  />
                ) : (
                  <></>
                )}
                {this.state.primary_owner !== undefined ? (
                  <FormAutocomplete
                    label={messages.primary_owner}
                    name="primary_owner"
                    onChange={(name, value) => this.setState({ primary_owner: value })}
                    autocompleteType="clientProvision"
                    disabled={this.props.formStatus.pending}
                    value={primary_owner}
                    returnValueObject
                  />
                ) : (
                  <></>
                )}
                <FormInput
                  type="number"
                  label={messages.provision_service_primary_rate}
                  name="primary_rate"
                  onChange={(name, value) => this.setState({ primary_rate: value })}
                  value={primary_rate}
                  disabled=""
                />
                {this.state.primary_owner !== undefined ? (
                  <FormAutocomplete
                    label={messages.secondary_owner}
                    name="primary_owner"
                    onChange={(name, value) => this.setState({ secondary_owner: value })}
                    autocompleteType="clientProvision"
                    disabled={this.props.formStatus.pending}
                    value={secondary_owner}
                    returnValueObject
                  />
                ) : (
                  <></>
                )}
                <FormInput
                  type="number"
                  label={messages.provision_service_secondary_rate}
                  name="secondary_rate"
                  onChange={(name, value) => this.setState({ secondary_rate: value })}
                  value={secondary_rate}
                  disabled=""
                />
                {this.props.pending || this.props.pendingC ? (
                  <Loader />
                ) : (
                  <Button
                    onClick={() => this.editServiceType()}
                    disabled={editDisabled}
                    bsStyle="primary"
                    className="pull-right"
                    title="create_service_type"
                  >
                    <span className="hidden-xs">{messages.save_provision_type}</span>
                  </Button>
                )}
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    appIntl: state.intl,
    defaultTimezone: getTimezoneFromState(state),
    formStatus: state.formStatus.clientProvisionEdit,
    serviceTypesClientR: state.provisionServiceTypes.serviceTypesClientR,
    serviceTypesR: state.provisionServiceTypes.serviceTypesR,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    editServiceTypeClientR: (id, data) => {
      dispatch(editServiceTypeClientR(id, data));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ClientProvisionServiceEdit)
);
